/* @author: Augusto Monteiro */

Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.Panel = function (id, tabConfig) {

    this.id = id;
    this.tabSelector = "#Panel_" + id;
    this.tabContainer = document.createElement("div");
    this.pagination = new Monet.UI.Pagination();
    this.header = new Greenmile.Panel.Header(id);
    this.cardList = new Greenmile.Panel.CardList(id);
    this.panelRules = [];
    this.firstResult = 0;
    this.maxResults = null;
    this.cardsPerPage = {};
    this.cardSize = {
        height: 145,
        width: 145
    };

    this.getPanel = function (callback) {
        Greenmile.Panel.Resources.getPanelById({
            id: id,
            onSuccess: function (panel) {
                this.panel = panel[0];
                const { id, name } = this.panel;
                callback();
            }.bind(this)
        });
    };

    this.render = function () {
        this.getPanel(function () {

            var tab = this.getTab();
            tab.className += " Panels";
            tab.appendChild(this.tabContainer);

            this.cardList.setPanelId(id);
            this.header.setPanelId(id);

            this.tabContainer.className = "tabContainer";
            this.tabContainer.appendChild(this.header.headerContainer);
            this.tabContainer.appendChild(this.cardList.cardContainer);

            this.calculateCardsPage();
            const cardSideToShow = this.getSideCardsToShow();

            this.cardList.setIsToFlipCards(cardSideToShow);
            this.cardList.render();
            this.addScrollEvent();

            if (tabConfig && !tabConfig.extra.name) {
              const { openAtLogin, id, name } = this.panel;
              const extra = { openAtLogin, id, name };
              window.GreenmileReduxStore.dispatch({
                type: 'GREENMILE_TAB_UPDATE_TITLE',
                payload: {
                  ...extra,
                  extra,
                  title: name,
                  key: `Panel_${this.panel.id}`,
                },
              });
            }

        }.bind(this));
    };

    this.getSideCardsToShow = () => {
        return this.panel?.cardSideToShow;
    };

    this.getTab = function () {
        return document.querySelector(this.tabSelector);
    };

    this.getId = function () {
        return parseInt(Monet.Utils.GetTabName().replace("Panel_", ""));
    };

    this.calculateCardsPage = function () {
        var body     = window.document.body
            , height = Math.floor((body.offsetHeight - 115) / this.cardSize.height)
            , width  = Math.floor(body.offsetWidth / this.cardSize.width);

        this.maxResults = (height * 2) * width;
        this.cardsPerPage = {
            width: width,
            height: height * 2
        };
    };

    this.addScrollEvent = function () {
        var el = this.getTab().querySelector(".CardContainer");

        this.pagination.setListElement(el);
        this.pagination.executePagination = this.executePagination;
        let timeoutId;

        const listener = () => {
            timeoutId && clearTimeout(timeoutId);
            timeoutId = setTimeout(this.pagination.scrollEventListenerFunction, 100);
        }

        el.removeEventListener('scroll', listener);
        el.addEventListener('scroll', listener);
    };

    this.executePagination = function () {
        this.cardList.paginate();
    }.bind(this);

};
